import { animeList } from "@/mocks/anime";

const top = animeList.slice(0, 6).map((a, i) => ({ ...a, rank: i + 1 }));

const badgeMap: Record<number, string> = {
  1: "bg-primary-500 text-background-50",
  2: "bg-accent-500 text-background-50",
  3: "bg-secondary-500 text-background-50",
};

export default function Rank() {
  return (
    <section id="rank" className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-start">
        <div className="lg:col-span-2">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
            <i className="ri-trophy-line"></i>
            人气榜单
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">
            萌宠番人气排行榜
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600 leading-relaxed">
            综合站内追番人数、评分与讨论热度实时生成。想知道最近大家都在追哪些狗狗主角动画与兽耳萌番？看这份榜单就对了。
          </p>
          <div className="mt-6 flex items-center gap-4">
            <div className="text-center">
              <p className="font-heading text-3xl text-primary-600">1500+</p>
              <p className="mt-1 text-xs text-foreground-500">收录番剧</p>
            </div>
            <div className="h-10 w-px bg-background-300"></div>
            <div className="text-center">
              <p className="font-heading text-3xl text-primary-600">12w+</p>
              <p className="mt-1 text-xs text-foreground-500">萌宠控用户</p>
            </div>
            <div className="h-10 w-px bg-background-300"></div>
            <div className="text-center">
              <p className="font-heading text-3xl text-primary-600">9.6</p>
              <p className="mt-1 text-xs text-foreground-500">平均评分</p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {top.map((a) => (
            <a
              key={a.id}
              href="#new"
              className="group flex items-center gap-3 rounded-2xl bg-background-100 border border-background-200/70 p-3 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-200"
            >
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg font-heading text-base ${
                  badgeMap[a.rank] ?? "bg-background-200 text-foreground-600"
                }`}
              >
                {a.rank}
              </span>
              <img
                src={a.image}
                alt={`${a.title}封面`}
                className="h-20 w-14 shrink-0 rounded-lg object-cover object-top"
              />
              <div className="min-w-0">
                <h3 className="truncate text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {a.title}
                </h3>
                <p className="mt-0.5 text-xs text-foreground-500">{a.tag}</p>
                <div className="mt-1 flex items-center gap-2 text-xs">
                  <span className="inline-flex items-center gap-0.5 text-accent-600">
                    <i className="ri-star-fill"></i>
                    {a.rating}
                  </span>
                  <span className="text-foreground-400">{a.episodes}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}